import React from 'react';
import { Shield, Rocket, Globe2, Coins } from 'lucide-react';

const features = [
  {
    icon: Shield,
    title: 'Secure Transactions',
    description: 'State-of-the-art security with verified identity protection - fully compliant and regulated'
  },
  {
    icon: Rocket,
    title: 'Instant Access',
    description: 'From cash to Bitcoin in minutes - hassle-free, no bank account needed'
  },
  {
    icon: Globe2,
    title: 'Universal Access',
    description: 'Bringing Bitcoin to every corner of Texas through our growing BTM network'
  },
  {
    icon: Coins,
    title: 'Competitive Rates',
    description: 'Real-time market prices with transparent fees displayed upfront'
  }
];

export default function Features() {
  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-white mb-12">
          Why Choose Us?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-800 p-6 rounded-lg transform hover:scale-105 transition-transform">
              <feature.icon className="w-12 h-12 text-purple-500 mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">{feature.title}</h3>
              <p className="text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}